import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getMedicationsClassification = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/medications_classification/', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getMedicationClassification = id => {
  return api.http.get(`/medications_classification/${id}`)
}

export const searchMedicationsClassification = term => {
  return api.http.get('/medications_classification/select_search', {
    params: {
      term
    }
  })
}

export const getSelectMedicationsClassification = (term, callback) => {
  searchMedicationsClassification(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteMedicationClassification = id => {
  return api.http.delete(`/medications_classification/${id}`)
}

export const restoreMedicationClassification = id => {
  return api.http.put(`/medications_classification/${id}/restore`)
}

export const editMedicationClassification = medicationClassification => {
  return api.http.put(
    `/medications_classification/${medicationClassification._id}`,
    medicationClassification
  )
}

export const addMedicationClassification = medicationClassification => {
  return api.http.post('/medications_classification', medicationClassification)
}



// WEBPACK FOOTER //
// ./src/api/medicationsClassification.js